import CryptoJS from "crypto-js";

const adminInfo = "adminInfo";
const loginTimeKey = "loginTime";
const TIME_SECRET = "webpage_secure_time";
const LOGIN_TIMEOUT_MS = 180 * 60 * 1000; // 3小时，可根据需求调整

function encryptLoginTime(timestamp) {
  return CryptoJS.AES.encrypt(timestamp.toString(), TIME_SECRET).toString();
}

function decryptLoginTime(cipherText) {
  if (!cipherText) return 0;
  try {
    const bytes = CryptoJS.AES.decrypt(cipherText, TIME_SECRET);
    const result = bytes.toString(CryptoJS.enc.Utf8);
    return Number(result) || 0;
  } catch (error) {
    return 0;
  }
}

function isLoginTimeout(timestamp) {
  if (!timestamp || isNaN(timestamp)) return true;
  return Date.now() - timestamp > LOGIN_TIMEOUT_MS;
}

export function isLoginExpired() {
  const admin = localStorage.getItem(adminInfo);
  if (!admin) return false;

  try {
    const parsed = JSON.parse(admin);
    const encryptedTime = parsed.loginTime || localStorage.getItem(loginTimeKey);
    const loginTime = decryptLoginTime(encryptedTime);
    if (isLoginTimeout(loginTime)) {
      removeAdminInfo();
      return true;
    }
    return false;
  } catch (error) {
    removeAdminInfo();
    return false;
  }
}

// 获取用户信息，并判断登录时间是否超时
export function getAdminInfo(_key) {
  void _key;
  const admin = localStorage.getItem(adminInfo);
  if (!admin) return "";

  try {
    const parsed = JSON.parse(admin);
    const encryptedTime = parsed.loginTime || localStorage.getItem(loginTimeKey);
    const loginTime = decryptLoginTime(encryptedTime);
    if (isLoginTimeout(loginTime)) {
      removeAdminInfo();
      return "";
    }
    return parsed;
  } catch (error) {
    removeAdminInfo();
    return "";
  }
}

// 存储用户信息，同时保存加密登录时间
export function setAdminInfo(admin) {
  const loginTime = Date.now();
  const encryptedTime = encryptLoginTime(loginTime);
  const adminWithTime = Object.assign({}, admin, { loginTime: encryptedTime });
  localStorage.setItem(adminInfo, JSON.stringify(adminWithTime));
  localStorage.setItem(loginTimeKey, encryptedTime);
}

// 设置或刷新登录时间
export function setLoginTime() {
  const encryptedTime = encryptLoginTime(Date.now());
  const admin = localStorage.getItem(adminInfo);
  if (admin) {
    try {
      const parsed = JSON.parse(admin);
      parsed.loginTime = encryptedTime;
      localStorage.setItem(adminInfo, JSON.stringify(parsed));
    } catch (error) {
      // ignore
    }
  }
  localStorage.setItem(loginTimeKey, encryptedTime);
}

// 移除用户信息
export function removeAdminInfo() {
  localStorage.removeItem(adminInfo);
  localStorage.removeItem(loginTimeKey);
  localStorage.removeItem("token");
  return true;
}
